module.exports = __webpack_public_path__ + "img/answer.1d9ffa1f.png";